import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  ListItem,
  Typography
} from '@mui/material';

interface Props {
  dialogOpen: boolean;
  handleConfirm: () => void;
  handleClose: () => void;
}

export const InfoDialog = (props: Props) => {
  return (
    <Dialog open={props.dialogOpen} onClose={props.handleClose}>
      <DialogTitle>Bitte beachten</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Sie legen mit dieser Funktion eine Veranstaltung im Hochschuldashboard an. <br />
          <br />
          Bitte klären Sie zuvor bei Veranstaltungen
          <ListItem>- mit Beteiligung bzw. Genehmigung durch die Hochschulleitung</ListItem>
          <ListItem sx={{ paddingY: 0, fontWeight: 'bold' }}>oder</ListItem>
          <ListItem>- mit wissenschaftlichem Charakter (z. B. Arbeitskreis, Kongress)</ListItem>
          <ListItem sx={{ paddingY: 0, fontWeight: 'bold' }}>oder</ListItem>
          <ListItem>
            - mit umfangreicherer Vorbereitung (z. B. geplante Bewirtung, Schließdienst)
          </ListItem>
          <ListItem sx={{ paddingY: 0, fontWeight: 'bold' }}>oder</ListItem>
          <ListItem>- mit erfolgter Genehmigung des Studierendenparlaments</ListItem>
          <Typography>die organisatorischen Details über diesen Link:</Typography>
          <br />
          <Link
            href=" https://intranet.th-rosenheim.de/veranstaltungsanmeldung/"
            style={{ display: 'flex', fontWeight: 'bold' }}
          >
            Veranstaltungsanmeldung
          </Link>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleConfirm} color="primary">
          Verstanden
        </Button>
      </DialogActions>
    </Dialog>
  );
};
